import type { MainContentProps } from "./MainContent";
import { MainContent } from "./MainContent";

export const PostViewListItem = (props: MainContentProps) => (
  <MainContent {...props} />
);
